import * as React from "react";
import styled from "styled-components";
import { InputGroup } from "components/bootstrap";
import { useWatchlist } from "watchlist/hooks/useWatchlistsV2";
const WatchlistInfo = styled(InputGroup.Addon)`
  width: auto;
  text-align: left;
  cursor: not-allowed;
`;
const WatchlistParameterPreview = ({ parameter: { watchlistId } }) => {
  const { data: watchlist } = useWatchlist(watchlistId);
  const label = watchlist ? `${watchlist.name}` : watchlistId;
  return /* @__PURE__ */ React.createElement(WatchlistInfo, null, "Watchlist: ", label);
};
export default WatchlistParameterPreview;
